import { axios } from '@/http/api'
import common from '@/http/response'
const URL = '/driver_document_expiry'

export default {
  getDriverDocuments (baseUrl, driverId) {
    return axios.get(baseUrl + URL + `/${driverId}/driver_documents`).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  },
  getTaxiDocuments (baseUrl, taxiId) {
    return axios.get(baseUrl + URL + `/${taxiId}/taxi_documents`).then((response) => {
      return common.prepareThen(response)
    }).catch((error) => {
      throw common.prepareCatch(error)
    })
  }
}
